var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vs-button-group"},_vm._l((_vm.items),function(item){return _c('vs-button',_vm._g({key:item.text,class:{ 'is-active': item.active },attrs:{"label":item.text,"icon":item.icon,"small":_vm.small,"to":item.to,"shrink":"","type":"secondary"}},_vm.getListeners(item)))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }